import React from 'react';
import { Card, Tag, Space } from 'antd';
import { CalendarOutlined, TagOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';

const { Meta } = Card;

const PostCard = ({ post, showActions = false, onEdit, onDelete }) => {
  return (
    <Card
      className="post-card"
      title={<Link to={`/post/${post.id}`}>{post.title}</Link>}
      extra={showActions && (
        <Space>
          <a onClick={() => onEdit(post)}>编辑</a>
          <a onClick={() => onDelete(post.id)} style={{ color: '#ff4d4f' }}>删除</a>
        </Space>
      )}
    >
      <Meta
        description={
          <div style={{ marginBottom: 12 }}>
            <Space>
              <CalendarOutlined />
              <span>{moment(post.date).format('YYYY-MM-DD')}</span>
              <TagOutlined />
              <span className="post-tags">
                {post.tags.map(tag => (
                  <Tag key={tag} color="blue">{tag}</Tag>
                ))}
              </span>
            </Space>
          </div>
        }
      />
      <p style={{ color: 'rgba(0, 0, 0, 0.65)' }}>
        {post.summary || post.content.substring(0, 100) + '...'}
      </p>
    </Card>
  );
};

export default PostCard;